import React, { useState } from 'react';
import Aux from '../../hoc/Aux';
import { useDispatch, useSelector } from 'react-redux'

import * as actions from '../../store/actions/index';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavItem from 'react-bootstrap/NavItem';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { LinkContainer } from 'react-router-bootstrap';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import {authLogout} from '../../store/actions/index';
import { ROUTES } from '../../routes';

import logo from '../../logo-hensel-ps.png';

import { useTranslation } from 'react-i18next';

const languageOptions = [
  { code: 'de', label: 'Deutsch' },
  { code: 'en', label: 'English' },
  { code: 'nl', label: 'Nederlands' },
  { code: 'fr', label: 'Français' },
  { code: 'no', label: 'Norsk' },
  { code: 'es', label: 'Español' },
  { code: 'sk', label: 'Slovenčina' }
];


const navigation = (props) => {

  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(false);
  const { width } = useWindowDimensions();
  const { t, i18n } = useTranslation();
  const changeLanguage = (lng) => { i18n.changeLanguage(lng); };
  const currentLanguage = (i18n.language || 'de').split('-')[0];
  const onLogoutHandler = () => { dispatch( authLogout() ); }

  const myProfile = useSelector(state => {
    return () => actions.getProfile(state)
  });

  let profile = myProfile() || {};

  const full_username = (profile["first_name"] || "") + " " + (profile["last_name"] || "")
  const lastLoginDate = profile["last_login"];

  const logoStyle = () => (width > 991)? {width: '200px'} : {width: '100px'};

  return (
    <Aux>
      <Navbar bg="dark" expand="lg" variant="dark" sticky="top" expanded={expanded}>
        <Navbar.Brand href="#home"><img src={logo} alt="Logo" style={logoStyle()} /></Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarResponsive" onClick={() => setExpanded((prevExpanded) => (prevExpanded = !prevExpanded))} />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="navbar-nav d-lg-block">
            <hr />

            {( props.isAuthenticated )?
              <Aux>
                <LinkContainer to="/" exact={true}>
                  <NavItem onClick={() => setExpanded(false)} className="nav-link">
                    {t('navigation.link.dashboard')}
                  </NavItem>
                </LinkContainer>
                <LinkContainer to={ROUTES.TO_PROJECTS} exact={false}>
                  <NavItem onClick={() => setExpanded(false)} className="nav-link">
                    {t('navigation.link.projects')}
                  </NavItem>
                </LinkContainer>
                <LinkContainer to={ROUTES.TO_WIZARD}>
                  <NavItem onClick={() => setExpanded(false)} className="nav-link">
                    {t('navigation.link.product_selector')}
                  </NavItem>
                </LinkContainer>

                <LinkContainer to={ROUTES.TO_DOCUMENTATIONS} exact={false}>
                  <NavItem onClick={() => setExpanded(false)} className="nav-link">
                    {t('navigation.link.documentations')}
                  </NavItem>
                </LinkContainer>


                <LinkContainer to={ROUTES.TO_HELP}>
                  <NavItem onClick={() => setExpanded(false)} className="nav-link">
                    {t('navigation.link.help')}
                  </NavItem>
                </LinkContainer>

                <hr />

                <LinkContainer to={ROUTES.TO_ACCOUNT} exact={false}>
                  <NavItem onClick={() => setExpanded(false)} className="nav-link">
                    {t('navigation.link.my_account')}
                  </NavItem>
                </LinkContainer>
                { full_username }
                { (lastLoginDate !== "")? <div>{ t('navigation.last_login_label') + " " + lastLoginDate } </div> : "" }

                <LinkContainer to={ROUTES.TO_LOGOUT}>
                  <NavItem onClick={onLogoutHandler} className="nav-link">
                    {t('navigation.link.logout')}
                  </NavItem>
                </LinkContainer>

                <hr />

                <LinkContainer to={ROUTES.TO_TERMS_OF_USE}>
                  <NavItem onClick={() => setExpanded(false)} className="nav-link">
                    {t('navigation.link.terms_of_use')}
                  </NavItem>
                </LinkContainer>
                <LinkContainer to={ROUTES.TO_DATENSCHUTZ}>
                  <NavItem onClick={() => setExpanded(false)} className="nav-link">
                    {t('navigation.link.privacy')}
                  </NavItem>
                </LinkContainer>
                <LinkContainer to={ROUTES.TO_IMPRESSUM}>
                  <NavItem onClick={() => setExpanded(false)} className="nav-link">
                    {t('navigation.link.impress')}
                  </NavItem>
                </LinkContainer>
                <LinkContainer to={ROUTES.TO_REVIT_PLUGIN}>
                  <NavItem onClick={() => setExpanded(false)} className="nav-link">
                    {t('navigation.link.revit_plugin')}
                  </NavItem>
                </LinkContainer>
              </Aux>
             :
              <Aux>
                <LinkContainer to={ROUTES.TO_LOGIN}>
                  <NavItem onClick={() => setExpanded(false)} className="nav-link">
                    {t('navigation.link.login')}
                  </NavItem>
                </LinkContainer>
                <LinkContainer to={ROUTES.TO_WIZARD}>
                  <NavItem onClick={() => setExpanded(false)} className="nav-link">
                    {t('navigation.link.product_selector')}
                  </NavItem>
                </LinkContainer>
                <LinkContainer to={ROUTES.TO_HELP}>
                  <NavItem onClick={() => setExpanded(false)} className="nav-link">
                    {t('navigation.link.help')}
                  </NavItem>
                </LinkContainer>
                <LinkContainer to={ROUTES.TO_REGISTER}>
                  <NavItem onClick={() => setExpanded(false)} className="nav-link">
                    {t('navigation.link.signup')}
                  </NavItem>
                </LinkContainer>

                <hr />

                <LinkContainer to={ROUTES.TO_TERMS_OF_USE}>
                  <NavItem onClick={() => setExpanded(false)} className="nav-link">
                    {t('navigation.link.terms_of_use')}
                  </NavItem>
                </LinkContainer>
                <LinkContainer to={ROUTES.TO_DATENSCHUTZ}>
                  <NavItem onClick={() => setExpanded(false)} className="nav-link">
                    {t('navigation.link.privacy')}
                  </NavItem>
                </LinkContainer>
                <LinkContainer to={ROUTES.TO_IMPRESSUM}>
                  <NavItem onClick={() => setExpanded(false)} className="nav-link">
                    {t('navigation.link.impress')}
                  </NavItem>
                </LinkContainer>
                <LinkContainer to={ROUTES.TO_REVIT_PLUGIN}>
                  <NavItem onClick={() => setExpanded(false)} className="nav-link">
                    {t('navigation.link.revit_plugin')}
                  </NavItem>
                </LinkContainer>
             </Aux>
           }


            <Aux>
              <hr />
              <NavDropdown
                title={
                  <span>
                    <i
                      aria-hidden="true"
                      className="material-icons"
                      style={{fontSize: '1rem', marginRight: '6px', verticalAlign: 'text-bottom'}}
                    >language</i>
                    {t('navigation.link.language')} ({currentLanguage.toUpperCase()})
                  </span>
                }
                id="basic-nav-dropdown"
              >
                {languageOptions.map(language => (
                  <NavDropdown.Item
                    active={currentLanguage === language.code}
                    aria-current={currentLanguage === language.code ? 'true' : undefined}
                    key={language.code}
                    lang={language.code}
                    onSelect={() => changeLanguage(language.code)}
                  >
                    {language.label}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>
            </Aux>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </Aux>
  )
};

export default navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js